import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { radius } from '@libertify/ui';
import { Logo } from './Logo';
import type { MediaProjectInstanceResponse } from '../types';

export type MobileDocHeaderProps = {
  publication: MediaProjectInstanceResponse;
  onShareClick?: () => void;
};

export const MobileDocHeader: React.FC<MobileDocHeaderProps> = ({
  publication,
  onShareClick,
}) => {
  const { t } = useTranslation(undefined, { useSuspense: false });

  return (
    <Wrapper>
      <LogoWrap>
        <Logo
          showLogo={true}
          projectId={publication?.project_id}
          margin={0}
          customUrl={publication?.assets?.Logo?.path}
        />
      </LogoWrap>
      <Actions>
        {onShareClick && (
          <ShareBtn onClick={onShareClick}>
            <svg
              width="13"
              height="13"
              viewBox="0 0 256 256"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M216,112v96a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V112A16,16,0,0,1,56,96H80a8,8,0,0,1,0,16H56v96H200V112H176a8,8,0,0,1,0-16h24A16,16,0,0,1,216,112ZM93.66,69.66,120,43.31V136a8,8,0,0,0,16,0V43.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,69.66Z" />
            </svg>
            {t('share', 'Share')}
          </ShareBtn>
        )}
      </Actions>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: white;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
  z-index: 10;
`;

const LogoWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 120px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ShareBtn = styled.button`
  background: #14b8a6;
  color: white;
  border: 2px solid #3bd4ca;
  border-radius: ${radius.pill}px;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;

  &:active {
    background: #0d9488;
  }
`;
